@use '../../styles/surface' as surface;
@use '../../styles/border' as border;
@use '../../styles/shadow' as shadow;

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.96);
  }
}

.trigger {
  outline: none;
}

.content {
  background-color: surface.$surface-full;
  border-radius: 10px;
  border: border.$border-width solid border.$border-muted;
  box-shadow: shadow.$shadow-m;
  padding: 12px;
  z-index: 1400;
  outline: none;
  transform-origin: var(--radix-popover-content-transform-origin);

  &[data-state='open'] {
    animation: fadeIn 200ms cubic-bezier(0.23, 1, 0.32, 1);
  }

  &[data-state='closed'] {
    animation: fadeOut 140ms cubic-bezier(0.23, 1, 0.32, 1);
  }
}
